import { Card, CardContent, Grid, Typography } from '@material-ui/core'
import { FormatQuote } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import i18n from '../i18n/i18n'

export const NewProfileWanted = () => {
  const site = useSelector(({ site }) => site)

  return (
    <Card elevation={0} style={{ backgroundColor: 'rgba(241, 81, 82, 0.1)' }} id="presentation">
      <CardContent className="geCard bigCard">

        <Typography component="h2" variant="h3">
          {i18n.t('main.whitemark.presentation')}
        </Typography>

        <Grid container direction="column" spacing={1}>
          <Grid item>
            <FormatQuote style={{ fontSize: 80 }} color="secondary" />
          </Grid>

          <Grid item>
            <Grid className="grid one">
              <Typography component="h3" variant="h1">
                {site.entity_as_json.name}
              </Typography>
            </Grid>
          </Grid>

          <Grid item>
            <Typography>
              {site.entity_as_json.description}
            </Typography>
          </Grid>
        </Grid>

      </CardContent>
    </Card>
  )
}
